<template>
  <div class="profile" v-if="contract">
    <v-tabs
      v-model="tab"
      background-color="blue"
      center-active
      dark
      centered
      fixed-tabs
      slider-color="blue darken-3"
      slider-size="3"
    >
      <v-tab>Datos básicos</v-tab>
      <v-tab>Colaborador</v-tab>
      <v-tab>Supervisores</v-tab>
      <v-tab>Certificados</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <v-row class="text-left">
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold"># Contrato:</span>
                <v-chip color="primary" small>
                  {{ contract.reference }}
                </v-chip>
              </v-col>
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold"
                  >Fecha de Inicio:</span
                >
                {{ contract.start_date }}
              </v-col>
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold"
                  >Salario Finalización:</span
                >
                {{ contract.end_date }}
              </v-col>
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold">Informes:</span>
                {{ contract.reports }}
              </v-col>
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold"
                  >Salario Mensual:</span
                >
                {{ contract.monthly_salary | formatNumber }}
              </v-col>
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold">Valor Total:</span>
                {{ contract.total_salary | formatNumber }}
              </v-col>
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold"
                  >Duración (Meses):</span
                >
                {{ contract.duration }}
              </v-col>
              <v-col cols="12" md="3">
                <v-chip
                  :color="getContractStatuColor(contract.status)"
                  dark
                  small
                >
                  {{ getContractStatus(contract.status) }}
                </v-chip>
              </v-col>
              <v-col cols="12" md="3" v-if="contract.contract_url">
                <v-btn
                  small
                  color="primary"
                  target="_blank"
                  rounded
                  :href="contract.contract_url"
                >
                  Contrato Documento
                </v-btn>
              </v-col>
              <v-col cols="12" md="3" v-if="contract.contract_signed_url">
                <v-btn
                  small
                  color="primary"
                  target="_blank"
                  rounded
                  :href="contract.contract_signed_url"
                >
                  Contrato Firmado
                </v-btn>
              </v-col>
              <v-col cols="12" md="3" v-if="!contract.contract_url">
                <v-btn small color="primary" rounded @click="createContractPdf">
                  Crear PDF
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-tooltip
          top
          v-if="
            contract.employee.can_create_bill_without_report &&
            role == 'EMPLOYEE'
          "
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              fab
              bottom
              right
              fixed
              color="blue"
              v-bind="attrs"
              v-on="on"
              dark
              class="btn__aling__top"
              @click="dialogBill = true"
            >
              <v-icon>mdi-text-box-plus</v-icon>
            </v-btn>
          </template>
          <span>Crear Cuenta Cobro</span>
        </v-tooltip>

        <v-tooltip top v-if="role == 'EMPLOYEE'">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              fab
              bottom
              right
              fixed
              color="green"
              v-bind="attrs"
              v-on="on"
              dark
              @click="upload"
            >
              <v-icon>mdi-file-upload</v-icon>
            </v-btn>
          </template>
          <span>Subir documentos</span>
        </v-tooltip>
      </v-tab-item>

      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <v-row class="text-left">
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold">Nombre:</span>
                {{ contract.employee.user.full_name }}
              </v-col>
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold">Cédula:</span>
                {{ contract.employee.user.colombian_id }}
              </v-col>
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold"
                  >Ciudad de expedición:</span
                >
                {{ contract.employee.expedition_city }}
              </v-col>
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold">Teléfono:</span>
                {{ contract.employee.user.phone }}
              </v-col>
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold">Dirección:</span>
                {{ contract.employee.user.address }}
              </v-col>
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold">Correo:</span>
                {{ contract.employee.user.email }}
              </v-col>
              <v-col cols="12" md="3">
                <v-chip
                  :color="getEmployeeStatuColor(contract.employee.status)"
                  dark
                  small
                >
                  {{ getEmployeeStatus(contract.employee.status) }}
                </v-chip>
              </v-col>
              <v-col cols="12" md="3">
                <span class="black--text font-weight-bold">Cargo:</span>
                {{ contract.employee.charge.name }}
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <v-data-table
          :headers="headers"
          :items="contract.supervisors"
          class="elevation-1 mb-7"
          no-data-text="No hay registros agregados..."
          hide-default-footer
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Supervisores</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="addSupervisor">Agregar</v-btn>
            </v-toolbar>
          </template>
          <template v-slot:[`item.full_name`]="item">
            {{ item.item.employee.user.full_name }}
          </template>
          <template v-slot:[`item.identification`]="item">
            {{ item.item.employee.user.full_name }}
          </template>
          <template v-slot:[`item.type`]="item">
            {{ getSupervisorType(item.item.type) }}
          </template>
          <template v-slot:[`item.actions`]="item">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="red"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="px-1"
                  @click="deleteSupervisor(item.item)"
                >
                  mdi-delete
                </v-icon>
              </template>
              <span>Eliminar</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-tab-item>

      <v-tab-item>
        <v-data-table
          :headers="certificateHeaders"
          :items="contract.certificates"
          class="elevation-1 mb-7"
          no-data-text="No hay registros agregados..."
          hide-default-footer
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Certificados</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="createCertificate"
                >Crear Certificado</v-btn
              >
            </v-toolbar>
          </template>
          <template v-slot:[`item.created_at`]="item">
            {{ item.item.created_at | dateFormat }}
          </template>
          <template v-slot:[`item.actions`]="item">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="blue"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="px-1"
                  @click="downloadCertificate(item.item)"
                >
                  mdi-download
                </v-icon>
              </template>
              <span>Descargar</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs-items>

    <!-- Dialog upload contract signed -->
    <v-dialog v-model="dialogUpload" width="550" persistent>
      <v-card>
        <v-card-title v-if="contract">
          Subir Contrato Firmado #{{ contract.reference }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="formUpload" v-model="formUpload">
            <v-file-input
              accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
              label="Contrato Firmado"
              v-model="model.contract_signed_file"
              :rules="[
                this.$store.state.rules.required,
                this.$store.state.rules.max_file,
              ]"
              show-size
            ></v-file-input>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="red" @click="cancelUpload">Cancelar</v-btn>
          <v-btn text color="primary" @click="saveUpload">Subir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog delete supervisor -->
    <v-dialog v-model="dialogSupervisor" persistent width="500">
      <v-card>
        <v-card-text class="py-4">
          Seguro que desea eliminar este supervisor?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            class="mr-4"
            @click="deleteSupervisorConfirmation"
            small
          >
            Confirmar
          </v-btn>

          <v-btn
            color="error"
            text
            class="mr-4"
            @click="dialogSupervisor = false"
            small
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog add supervisor -->
    <v-dialog v-model="dialogAddSupervisor" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Agregar Supervisor</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="formSupervisor" v-model="formAddSupervisor">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-select
                    :items="supervisorStatus"
                    v-model="modelSupervisor.type"
                    label="Tipo"
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="modelSupervisor.identification"
                    label="Identificación"
                    append-outer-icon="mdi-account-search"
                    @click:append-outer="findEmployee('SUPERVISOR')"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="modelSupervisor.full_name"
                    label="Nombre"
                    disabled
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeSupervisor">
            Cancelar
          </v-btn>
          <v-btn color="blue darken-1" text @click="saveSupervisor">
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog create bill -->
    <v-dialog v-model="dialogBill" width="500" persistent>
      <v-card>
        <v-card-text v-if="contract" class="pt-4">
          <h3>
            Seguro que desea generar cuenta de cobro para el contrato #{{
              contract.reference
            }}?
          </h3>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="red" @click="dialogBill = false">Cancelar</v-btn>
          <v-btn text color="primary" @click="createBill">Crear</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_CONTRACT } from "@/store/contract";
import { SET_ALERT } from "@/store/alert";
import { SET_EMPLOYEES } from "@/store/employee/employees";
export default {
  name: "ShowContract",
  filters: {
    formatNumber(value) {
      return new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
      }).format(value);
    },
    dateFormat(date) {
      date = new Date(date);
      return date.toLocaleString("en-US");
    },
  },
  data: () => ({
    tab: null,
    contract: null,
    dialogBill: false,
    dialogSupervisor: false,
    dialogAddSupervisor: false,
    currentSupervisor: null,
    formAddSupervisor: true,
    formUpload: true,
    dialogUpload: false,
    modelSupervisor: {
      full_name: "",
      identification: "",
      type: "",
      employee_id: "",
    },
    model: {
      contract_signed_file: null,
    },
    headers: [
      { text: "Nombre", value: "full_name", sortable: false },
      { text: "Identificación", value: "identification", sortable: false },
      { text: "Tipo", value: "type", sortable: false },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    certificateHeaders: [
      { text: "Fecha", value: "created_at", sortable: false },
      { text: "Acciones", value: "actions", sortable: false },
    ],
  }),
  created() {
    this.$store.dispatch("getContract", this.$route.params.id);
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === SET_CONTRACT) {
        this.contract = state.contract.contract;
      }
      if (mutation.type === SET_EMPLOYEES) {
        if (state.employee.employees.employees.data.length > 0) {
          this.currentEmployee = state.employee.employees.employees.data[0];
          this.setDataSupervisor();
        } else {
          this.clearInputsSupervisor();
        }
      }
    });
  },
  computed: {
    ...mapGetters([
      "getContractStatus",
      "getContractStatuColor",
      "getEmployeeStatuColor",
      "getEmployeeStatus",
      "getSupervisorType",
    ]),
    supervisorStatus() {
      return this.$store.state.status.supervisorType;
    },
    role() {
      return this.$store.state.user.user != null
        ? this.$store.state.user.user.role
        : "";
    },
  },
  methods: {
    deleteSupervisor(supervisor) {
      this.currentSupervisor = supervisor;
      this.dialogSupervisor = true;
    },
    deleteSupervisorConfirmation() {
      this.$store.dispatch("deleteSupervisor", this.currentSupervisor.id);
      this.dialogSupervisor = false;
    },
    findEmployee() {
      this.$store.dispatch(
        "getEmployees",
        "colombian_id=" + this.modelSupervisor.identification + "&"
      );
    },
    addSupervisor() {
      this.dialogAddSupervisor = true;
    },
    saveSupervisor() {
      //Validate inputs
      if (
        this.modelSupervisor.type == "" ||
        this.modelSupervisor.employee_id == ""
      ) {
        this.$store.commit(SET_ALERT, {
          message: "Todos los campos son obligatorios",
          type: "error",
        });
        return;
      }
      //Validate if the employee is the headline of the contract
      /* if (this.contract.employee.id == this.modelSupervisor.employee_id) {
        this.$store.commit(SET_ALERT, {
          message: "No puede agregar al titular del contrato como supervisor",
          type: "error",
        });
        return;
      } */
      //Validate if the supervisor is added
      if (
        this.contract.supervisors.find(
          (obj) => obj.employee_id == this.modelSupervisor.employee_id
        )
      ) {
        this.$store.commit(SET_ALERT, {
          message: "Este supervisor se encuentra agregado",
          type: "error",
        });
        return;
      }

      this.modelSupervisor.contract_id = this.contract.id;
      this.$store.dispatch("createSupervisor", this.modelSupervisor);
      this.closeSupervisor();
    },
    closeSupervisor() {
      this.dialogAddSupervisor = false;
      this.modelSupervisor = {
        full_name: "",
        identification: "",
        type: "",
        employee_id: "",
      };
    },
    setDataSupervisor() {
      this.modelSupervisor.employee_id = this.currentEmployee.id;
      this.modelSupervisor.full_name = this.currentEmployee.user.full_name;
    },
    clearInputsSupervisor() {
      this.modelSupervisor.employee_id = "";
      this.modelSupervisor.full_name = "";
    },
    upload() {
      this.dialogUpload = true;
    },
    cancelUpload() {
      this.dialogUpload = false;
      this.model = {
        support_file: null,
        payroll_file: null,
      };
    },
    saveUpload() {
      if (this.model.contract_signed_file == null) {
        this.$store.commit(SET_ALERT, {
          message: "Debe seleccionar los archivos",
          type: "error",
        });
        return;
      }

      this.model._method = "put";
      this.$store.dispatch("updateContract", {
        id: this.contract.id,
        form: this.createFormData(),
      });
      this.cancelUpload();
    },
    createFormData() {
      let formData = new FormData();
      Object.entries(this.model).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((element, index) => {
            formData.append(key + "[" + index + "]", element);
          });
        } else {
          if (value !== null && value !== "") {
            formData.append(key, value);
          }
        }
      });
      return formData;
    },
    createContractPdf() {
      this.$store.dispatch("createContractPdf", {
        id: this.contract.id,
        reference: this.contract.reference,
      });
    },
    downloadCertificate(certificate) {
      window.open(certificate.certificate_url, "_blank");
    },
    createCertificate() {
      this.$store.dispatch("createCertificate", {
        contract_id: this.contract.id,
      });
    },
    createBill() {
      this.$store.dispatch("createBill", {
        contract_id: this.contract.id,
      });
      this.dialogBill = false;
    },
  },
};
</script>
<style scoped>
.profile {
  height: 100%;
}
.v-btn--bottom {
  bottom: 25px !important;
}
.btn__aling__top {
  bottom: 95px !important;
}
</style>
